export const EnergyLevel = {
  1: 'Very Light',
  2: 'Light',
  3: 'Moderate',
  4: 'Active',
  5: 'Intense',
}